// Klucz porównawczy produktu: bez wielkości liter, polskich znaków, ilości i gramatury.

const START = String.raw`(?<![\p{L}\p{N}])`;
const END = String.raw`(?![\p{L}\p{N}])`;

// Tekst jest już bez znaków diakrytycznych („gramów” → „gramow”).
const UNIT = [
  'kilogram(?:y|ow|a)?|kilo|kg',
  'dekagram(?:y|ow|a)?|deko|deka|dkg|dag',
  'gram(?:y|ow|a)?|gr|g',
  'mililitr(?:y|ow|a)?|ml',
  'litr(?:y|ow|a)?|l',
  'sztuk[aiey]?|szt',
  'opakowan(?:ie|ia)?|opak|opk|op',
].join('|');

/** „2%”, „3,2%”, „500 g”, „1l”, „10 szt”, „pol litra”. */
const QUANTITY_RE = new RegExp(String.raw`${START}(?:\d+(?:[.,]\d+)?\s*|pol\s+)(?:%|(?:${UNIT})${END})`, 'gu');
/** „2x”, „x2”, „x 2”. */
const TIMES_RE = new RegExp(String.raw`${START}(?:\d+\s*x|x\s*\d+)${END}`, 'gu');
const NUMBER_RE = new RegExp(String.raw`${START}\d+${END}`, 'gu');

export function normKey(name: string): string {
  return name
    .toLowerCase()
    .replace(/ł/g, 'l')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/['’`]/g, '')
    .replace(/[×*]/g, ' x ')
    .replace(/(\d)x(?=\d)/g, '$1 x ') // „6x1,5l”
    .replace(QUANTITY_RE, ' ')
    .replace(TIMES_RE, ' ')
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .replace(NUMBER_RE, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
